export default {
  title: 'Cambios sin guardar',
  text: 'Estás en modo de edición y tus cambios no se han guardado. ¿Estás seguro de que quieres salir sin guardar?',
  continueWithoutSaving: 'Continuar sin guardar',
  cancel: 'Cancelar'
}

export const en = {
  title: 'Unsaved changes',
  text: 'You\'re in edit mode and changes haven\'t been saved. Are you sure you want to quit without saving?',
  continueWithoutSaving: 'Continue without saving',
  cancel: 'Cancel'
}

export const ca = {
  title: 'Canvis sense desar',
  text: 'Estàs en mode d\'edició, els teus canvis no s\'han desat. Estàs segur que vols sortir sense desar?',
  continueWithoutSaving: 'Continua sense desar',
  cancel: 'Cancel·la'
}
